//@flow

import { getEntitySettings } from 'common/redux/selectors/clientSelector';
import { type AppState } from 'common/redux/reducers';
import type { TerritoryPlanningContainerProps } from 'common/components/territory/TerritoryPlanningContainer';
import * as Immutable from 'immutable';

export const getCustomDistributorField = function (
    state: AppState,
    props: TerritoryPlanningContainerProps
) {
    const entitySettings = getEntitySettings(state, props);
    const outletDistributorSettings = entitySettings.outletSettings.customFields.find(
        customField => customField.key === 'distributor'
    );
    if (!outletDistributorSettings) {
        return Immutable.List([]);
    }
    const allDistributorValues =
        outletDistributorSettings.metadata.possibleValues;
    return allDistributorValues;
};

export const isDistributorOutletsLoading = function (state: AppState): boolean {
    const { territoryPlanning } = state;
    const isDistributorOutletsLoading = territoryPlanning.getIn([
        'territory',
        'distributor',
        'isLoading'
    ]);
    return isDistributorOutletsLoading;
};

export const isNonDistributorOutletsLoading = function (
    state: AppState
): boolean {
    const { territoryPlanning } = state;
    const isDistributorOutletsLoading = territoryPlanning.getIn([
        'territory',
        'nonDistributor',
        'isLoading'
    ]);
    return isDistributorOutletsLoading;
};

export const isHomebaseLoading = function (state: AppState) {
    const { territoryPlanning } = state;
    const isHomebaseLoading = territoryPlanning.getIn([
        'territory',
        'homeBases',
        'isLoading'
    ]);
    return isHomebaseLoading;
};

export const isCreateMapInProgress = function (state: AppState) {
    const { territoryPlanning } = state;
    const isCreateMapInProgress = territoryPlanning.getIn([
        'territory',
        'creatingNewZoneMapInProgress'
    ]);
    return isCreateMapInProgress;
};

export const isUpdateOutletInProgress = function (state: AppState) {
    const { territoryPlanning } = state;
    const isUpdateOutletInProgress = territoryPlanning.getIn([
        'territory',
        'updateOutletInProgress'
    ]);
    return isUpdateOutletInProgress;
};

export const isUnassignOutletInProgress = function (state: AppState) {
    const { territoryPlanning } = state;
    const isUnassignOutletInProgress = territoryPlanning.getIn([
        'territory',
        'unassignOutletInProgress'
    ]);
    return isUnassignOutletInProgress;
};

export const isSortInProgress = function (state: AppState) {
    const { territoryPlanning } = state;
    const isSortInProgress = territoryPlanning.getIn([
        'territory',
        'sortOutlet',
        'isLoading'
    ]);
    return isSortInProgress;
};
